import React, { useMemo } from "react";
import HeaderMobileMenu from "./header/header-mobile-menu";
import HeaderDesktopMenu from "./header/header-desktop-menu";
import { ApiResponse } from "@/types/api";
import { IHeaderCategories, IInformationSingle } from "@/types/header";

export interface HeaderMenuData {
  categories: IHeaderCategories[];
  informations: IInformationSingle[];
  contact: string;
  lang: string;
}

interface HeaderMenuProps {
  mobileMenu: boolean;
  setMobileMenu: (mobileMenu: boolean) => void;
  data: ApiResponse<HeaderMenuData>;
}

const HeaderMenu: React.FC<HeaderMenuProps> = ({ mobileMenu, setMobileMenu, data }) => {
  const headerMenuData = useMemo(() => {
    if (data?.success) {
      return {
        categories: data.data.categories,
        informations: data.data.informations,
        contact: data.data.contact,
      };
    }
    return {
      categories: [],
      informations: [],
      contact: "",
    };
  }, [data]);

  const { categories, informations, contact } = headerMenuData;

  return (
    <>
      <HeaderMobileMenu
        mobileMenu={mobileMenu}
        setMobileMenu={setMobileMenu}
        categories={categories}
        contact={contact}
        informations={informations}
      />

      <HeaderDesktopMenu categories={categories} />
    </>
  );
};

export default React.memo(HeaderMenu);
